var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32169 6.10294C9.75126 5.67337 10.4478 5.67337 10.8773 6.10294L16.3774 11.603C16.807 12.0326 16.807 12.7291 16.3774 13.1587L10.8773 18.6587C10.4478 19.0883 9.75126 19.0883 9.32169 18.6587C8.89212 18.2292 8.89212 17.5327 9.32169 17.1031L14.0439 12.3809L9.32169 7.65859C8.89212 7.22902 8.89212 6.53251 9.32169 6.10294Z",
    fill: "#143578"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2998 12.3811C1.2998 11.7735 1.79228 11.281 2.39986 11.281H15.6C16.2075 11.281 16.7 11.7735 16.7 12.3811C16.7 12.9886 16.2075 13.481 15.6 13.481H2.39986C1.79228 13.481 1.2998 12.9886 1.2998 12.3811Z",
    fill: "#143578"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2 3.58064C19.4917 3.58064 19.7715 3.69654 19.9778 3.90283C20.1841 4.10912 20.3 4.38892 20.3 4.68066V20.0808C20.3 20.3726 20.1841 20.6524 19.9778 20.8586C19.7715 21.065 19.4917 21.1808 19.2 21.1808H14.7999C14.1924 21.1808 13.6999 21.6734 13.6999 22.2809C13.6999 22.8884 14.1924 23.3809 14.7999 23.3809H19.2C20.0752 23.3809 20.9146 23.0332 21.5334 22.4143C22.1523 21.7954 22.5 20.9561 22.5 20.0808V4.68066C22.5 3.80543 22.1523 2.96605 21.5334 2.34718C20.9146 1.7283 20.0752 1.38062 19.2 1.38062H14.7999C14.1924 1.38062 13.6999 1.87311 13.6999 2.48063C13.6999 3.08815 14.1924 3.58064 14.7999 3.58064H19.2Z",
    fill: "#143578"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogIn);
export default __webpack_public_path__ + "static/media/LogIn.1b3ecbf7581030631992093e0a054737.svg";
export { ForwardRef as ReactComponent };